import "@/App.css";
import { Toaster } from "sonner";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Expertise } from "@/components/Expertise";
import { Experience } from "@/components/Experience";
import { Awards } from "@/components/Awards";
import { Achievements } from "@/components/Achievements";
import { Services } from "@/components/Services";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-bone">
      <Toaster position="top-center" richColors />
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Expertise />
        <Experience />
        <Awards />
        <Achievements />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
